import $ from 'jquery';

function CACLoginPage() {
  const heroContent = '<div class="heroPane" id="heroPane"><div class="overlay"> <div class="contentWrapper"> <div class="titleWrapper"> <hr align="left" class="titleDivider titleDividerColor"> <span class="title">Login</span> </div> <div class="description">By signing in, you are agreeing to the U.S. DoD Terms of Service and user agreement.</div> </div> </div> </div>';

  if ($('#dnn_ctr_Login_DMAAuthentication').length || $('#dnn_ctr_Login_DNN').length) {
    $('.empty-container').addClass('cac-login-hero');
    $('.empty-container').prepend(heroContent);
  }
}

export default CACLoginPage;
